import CreateTabBannerSlot from './CreateTabBannerSlot';

export { default as useBannerSlot } from './useBannerSlot';

export default CreateTabBannerSlot;
